import { useClientPortalEoirInternalSampleStore } from '@/lib/stores/client-portal-eoir-internal-sample-store'

export const useClientPortalEoirInternalSampleContent = () => {
  const { currentCase } = useClientPortalEoirInternalSampleStore()

  const caseData = currentCase.caseInformation
  const companyData = currentCase.company
  const historyData = currentCase.history
  const scheduledAlertsData = currentCase.alertSchedule

  const showsOtherCriticalDates = currentCase.portalOption.alertSchedule

  return { caseData, companyData, historyData, scheduledAlertsData, showsOtherCriticalDates }
}
